/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type {TaxAccountantDto} from './TaxAccountantDto';

export type TaxSystemIntegrationDto = {
    readonly _permissions?: Array<string>;
    accountant?: TaxAccountantDto;
    created?: string;
    creator?: string;
    creatorId?: string;
    enabled?: boolean;
    id?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    name?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    password?: string;
    system?: TaxSystemIntegrationDto.software;
    selfSignedCertificate?: boolean;
    url?: string;
    username?: string;
};

export namespace TaxSystemIntegrationDto {

    export enum software {
        POHODA = "POHODA",
        POHODA_SQL = "POHODA_SQL",
        FLEXIBEE = "FLEXIBEE",
        MONEYS3 = "MONEYS3",
        MONEYS3_API = "MONEYS3_API",
        ISDOC = "ISDOC",
        OTHER = "OTHER",
    }
}

